var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipmentDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.25C9.78408 19.25 9.10018 18.9611 7.73231 18.3833C4.32744 16.945 2.625 16.2258 2.625 15.0161C2.625 14.6774 2.625 8.80644 2.625 6.125M10.5 19.25C11.2159 19.25 11.8998 18.9611 13.2677 18.3833C16.6726 16.945 18.375 16.2258 18.375 15.0161V6.125M10.5 19.25V9.93545",
    stroke: "#003371",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28518 8.47996L4.72913 7.24312C3.32637 6.56434 2.625 6.22495 2.625 5.6875C2.625 5.15005 3.32637 4.81066 4.72913 4.13188L7.28518 2.89504C8.8627 2.13168 9.65151 1.75 10.5 1.75C11.3485 1.75 12.1373 2.13167 13.7148 2.89504L16.2709 4.13188C17.6736 4.81066 18.375 5.15005 18.375 5.6875C18.375 6.22495 17.6736 6.56434 16.2709 7.24312L13.7148 8.47996C12.1373 9.24332 11.3485 9.625 10.5 9.625C9.65151 9.625 8.8627 9.24332 7.28518 8.47996Z",
    stroke: "#003371",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 10.5L7 11.375",
    stroke: "#003371",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 3.5L6.125 7.875",
    stroke: "#003371",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentDashboard);
export default __webpack_public_path__ + "static/media/shipment-dashboard.5f045d26ea6091699eb2f0a4e3e84dfa.svg";
export { ForwardRef as ReactComponent };